const KNOWN_ACCESS_STATES = new Set([
  'free',
  'new',
  'trialing',
  'active',
  'cancel_scheduled',
  'grace',
  'lapsed',
  'downgrade_scheduled',
]);

export function isRecognizedBillingState(entitlements) {
  return Boolean(entitlements
    && KNOWN_ACCESS_STATES.has(entitlements.accessState)
    && typeof entitlements.cancelAtPeriodEnd === 'boolean');
}

// Catalog plan, payment history and period-end dates are not access grants.
// In particular a Test Clock period end can be in the wall-clock future.
export function effectiveAccessState(entitlements) {
  if (!isRecognizedBillingState(entitlements)) return null;
  if (entitlements.effectivePlan === 'lapsed') return 'lapsed';
  return entitlements.accessState;
}

export function canResumeSubscription(entitlements) {
  return ['active', 'trialing', 'grace', 'cancel_scheduled', 'downgrade_scheduled'].includes(effectiveAccessState(entitlements))
    && entitlements.cancelAtPeriodEnd === true
    && !['canceled', 'incomplete_expired'].includes(entitlements.paymentIssue?.status);
}

export function subscriptionResumeHasConverged(entitlements) {
  return Boolean(isRecognizedBillingState(entitlements)
    && entitlements.accessState !== 'cancel_scheduled'
    && entitlements.cancelAtPeriodEnd === false);
}

export function trialActivationHasConverged(entitlements) {
  return Boolean(entitlements
    && entitlements.accessState === 'active'
    && entitlements.cancelAtPeriodEnd === false
    && (entitlements.billingStatus || entitlements.subscriptionStatus) === 'active');
}
